<template>
  <div class="feedback-container">
    <div class="feedback-wrapper">
      <div class="feedback-title-view">
        <div class="feedback-title">菜金错误信息</div>
      </div>
      <div class="break-line"/>
      <div class="feedback-form">
        <textarea placeholder="请输入错误信息，格式如：2019年3月22 午餐/加班餐 多/少+金额" v-model="feedbackInfo" class="feedback-area" />
        <div @click="confirmFeedback" class="feedback-btn">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { monthFormat } from '../../utils/time'
  export default {
    name: 'Feedback',
    data () {
      return {
        feedbackInfo: ''
      }
    },
    methods: {
      confirmFeedback () {
        // TODO:
        if (this.feedbackInfo === '') {
          this.$store.commit('show_alert', '反馈信息不能为空')
          return
        }
        let params = {
          problem: this.feedbackInfo
        }
        // 菜金纠错
        this.APIS.CORRECT_MENU_MONEY(params)
        .then((res) => {
          if (res.data.status === 0) {
            this.$store.commit('show_alert', '反馈成功')
            this.$store.commit('set_is_feedback', 1)
            this.$router.push('/p/user/money')
          } else {
            this.$store.commit('show_alert', res.data.message)
          }
        })
        .catch((err) => {
          console.log(err)
        })
      }
    }
  }
</script>

<style scoped lang='less'>
.feedback-container {
  width: 100%;
  display: flex;
  justify-content: center;
  .feedback-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .feedback-title-view {
      width: 900px;
      .feedback-title {
        font-size: 20px;
        color: #333333;
        margin-top: 30px;
      }
    }
    .break-line {
      width: 900px;
      margin: 20px 0;
      border-bottom: 1px solid #e0e0e0;
    }
    .feedback-form {
      width: 900px;
      .feedback-area {
        box-sizing: border-box;
        width: 900px;
        height: 216px;
        border: 1px solid #e0e0e0;
        outline: none;
        resize: none;
        padding: 15px 20px;
        color: #333;
        font-size: 16px;
        line-height: 24px;
      }
      .feedback-btn {
        margin: 40px auto;
        text-align: center;
        line-height: 54px;
        width: 240px;
        height: 54px;
        border-radius: 27px;
        background: #ff9a28;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/feedback.vue